import { useEffect } from 'react';

import { AlertVariant } from '@patternfly/react-core';

import type LiveClassStore from 'stores/LiveClass';

type UseLiveClassEnrollmentAlertOptions = {
  liveClassStore: LiveClassStore;
  addAlert: (options: {
    title: string;
    children: string;
    variant: typeof AlertVariant.success;
    key: string;
    timeout: number;
    className: string;
  }) => void;
};

export default function useLiveClassEnrollmentAlert({
  liveClassStore,
  addAlert,
}: UseLiveClassEnrollmentAlertOptions) {
  useEffect(() => {
    if (Object.keys(liveClassStore.enrollmentSuccessAlert).length === 0) return;

    addAlert({
      title: liveClassStore.enrollmentSuccessAlert.title,
      children: liveClassStore.enrollmentSuccessAlert.message,
      variant: AlertVariant.success,
      key: 'live-class-enrollment',
      timeout: 5000,
      className: 'live-class-enrollment-success-alert',
    });
    // eslint-disable-next-line no-param-reassign -- clearing store state after showing alert
    liveClassStore.enrollmentSuccessAlert = {};
  }, [liveClassStore.enrollmentSuccessAlert, addAlert, liveClassStore]);
}
